import { Box, darken, List, Modal, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { QuizModal } from '../../components/ModalEditWindow/modalComponents/Quiz';
import QuizTypes from '../../constants/quiz';

export const QUIZ_STATUS_COLORS = {
    PASSED: '#58a315',
    INCOMPLETE: '#FFD700',
    PENDING: '#606060',
    EXPIRED: '#FF6347',
};

const StyledListItem = styled.li`
    display: flex;
    align-items: center;
    justify-content: space-between;
    background-color: ${({ ...props }) => {
        return props.theme?.palette?.mode === 'dark' ? '#464646' : 'white';
    }};
    border-radius: 8px;
    padding: 10px;
`;

const getStatusColor = status => QUIZ_STATUS_COLORS[status] || '#606060';

const StyledButton = styled.button`
    background-color: ${({ status }) => getStatusColor(status)};
    color: white;
    cursor: pointer;
    border: none;
    padding: 8px 16px;
    border-radius: 4px;
    transition: background-color 0.3s;
    &:hover {
        background-color: ${({ status }) => darken(getStatusColor(history.status), 0.2)};
    }
`;

export const QuizPage = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const { histories, isOpen } = useSelector(state => state.quiz);

    const handleOpen = quizId => {
        dispatch({
            type: QuizTypes.SET_SHOW_RESULT,
            payload: false,
        });
        dispatch({
            type: QuizTypes.SET_SELECTED_QUIZ_ID,
            payload: quizId,
        });
        dispatch({
            type: QuizTypes.SET_QUIZ_OPEN,
            payload: true,
        });
    };

    const handleClose = () => {
        dispatch({
            type: QuizTypes.SET_SELECTED_QUIZ_ID,
            payload: null,
        });
        dispatch({
            type: QuizTypes.SET_QUIZ_OPEN,
            payload: false,
        });
    };

    return (
        <>
            {histories?.length ? (
                <>
                    <List
                        sx={{
                            maxWidth: '600px',
                            display: 'flex',
                            flexDirection: 'column',
                            gap: 2,
                            margin: '0 auto',
                        }}
                    >
                        {histories.map(history => (
                            <StyledListItem key={history.id}>
                                <Box sx={{ display: 'flex', gap: 0.5, alignItems: 'center' }}>
                                    <Typography component="span">№{history.template_id}</Typography>
                                    <Typography component="span">{history.theme}</Typography>
                                </Box>
                                <StyledButton
                                    status={history.status}
                                    onClick={() => {
                                        handleOpen(history.id);
                                    }}
                                >
                                    {t('quiz.start')}
                                </StyledButton>
                            </StyledListItem>
                        ))}
                    </List>

                    <Modal
                        open={isOpen}
                        onClose={handleClose}
                        aria-labelledby="parent-modal-title"
                        aria-describedby="parent-modal-description"
                    >
                        <QuizModal />
                    </Modal>
                </>
            ) : (
                <Typography style={{ textAlign: 'center', padding: '1rem' }}>{t('quiz.noQuizzesAlert')}</Typography>
            )}
        </>
    );
};
